import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import axios, { AxiosPromise } from 'axios'
import { AloMedia,cleanAloMedia } from '@/models/alo/AloMedia'

export default {
  /*getAllMedia(): AxiosPromise<AlrContainer<Array<AloMedia>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Media`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloMedia>>
      }]
    })
  },*/
  getMedia(id:number):AxiosPromise<AlrContainer<AloMedia>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Media/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloMedia>
      }]
    })
  },
  saveMedia(media:AloMedia):AxiosPromise<AlrContainer<AloMedia>> {
    cleanAloMedia(media)
    if(media.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Media/${media.id}`, 
        method: 'PUT',
        data: media,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloMedia>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Media`, 
        method: 'POST',
        data: media,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloMedia>
        }]
      })    
    }
  },
  deleteMedia(id:number):AxiosPromise<AlrContainer<AloMedia>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Media/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloMedia>
      }]
    })
  },
  upload({file,name,progress}:{file:File,name:string|null,progress:(e:ProgressEvent)=>void|null}) {    
    const formData = new FormData();
    formData.append("data", file, file.name);    
    formData.append("name",name??file.name);        
    return  axios({ 
      url: `/webapi/Media/upload`, 
      method: 'POST',
      data: formData,
      headers: {'Content-Type': 'multipart/form-data'},        
      onUploadProgress:progress,    
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloMedia>
      }]
    }) as AxiosPromise<AlrContainer<AloMedia>>
  }
}